import React from 'react';
import { Button, InformationIcon } from 'tuui';
import { useSimulatorButton } from 'components/SimulatorButton/useSimulatorButton';
import { useIsSimulatorInDrawerStack } from 'hooks';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import { useMultiLayerPathParams } from 'modules/taboola-common-frontend-modules/multi-layer-drawer/hooks/useMultiLayerPathParams';
import styles from './budgetSimulatorSection.module.scss';

export const BudgetSimulatorSection = () => {
    const { accountId, campaignId } = useMultiLayerPathParams();

    const { shouldRender, handleClick } = useSimulatorButton({
        campaignId,
        accountId,
        monitorId: 'simulator-button-edit-campaign',
    });
    const isSimulatorInDrawerStack = useIsSimulatorInDrawerStack();

    if (!shouldRender || isSimulatorInDrawerStack) {
        return null;
    }

    return (
        <div className={styles.container}>
            <div className={styles.content}>
                <div className={styles['icon-wrapper']}>
                    <InformationIcon className={styles.icon} />
                </div>
                <div className={styles.message}>
                    <FormattedMessage
                        id="campaign.simulator.cta.title"
                        defaultMessage="See how changes could impact your campaign performance."
                    />
                </div>
            </div>
            <Button variant={Button.variant.text} id="budget-simulator-open-button" onClick={handleClick}>
                <FormattedMessage id="campaign.simulator.cta.button" defaultMessage="Open simulator" />
            </Button>
        </div>
    );
};
